
import axios from 'axios';
import authHeader from './auth-header'; // Asegúrate de que esto esté configurado

const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {
    // Listado paginado con búsqueda (módulo de configuración)
    getAll(params = null) {
        const queryString = params ? new URLSearchParams(params).toString() : '';
        const url = `${API_URL}/supplies${queryString ? `?${queryString}` : ''}`;

        return axios.get(url, { headers: authHeader() });
    },
    // Catálogo completo de insumos activos (para selects)
    getList() {
        return axios.get(`${API_URL}/supplies?all=1`, { headers: authHeader() });
    },
    getData(id) {
        return axios.get(`${API_URL}/supplies/${id}`, { headers: authHeader() });
    },
    createData(data) {
        return axios.post(`${API_URL}/supplies`, data, { headers: authHeader() });
    },
    updateData(id, data) {
        return axios.put(`${API_URL}/supplies/${id}`, data, { headers: authHeader() });
    },
    deleteData(id) {
        return axios.delete(`${API_URL}/supplies/${id}`, { headers: authHeader() });
    },
};
